import React, {useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";

import "./Footer.css";
import packageJson from "@app/../package.json";
import { useTranslation } from "react-i18next";
import {
  MULTITENANT_CONSTANTS,
  TENANT,
} from "../../../Resources/Multitenant/tenantConstants";
import { URL_BASE_IMAGE } from "../../../services/servicesConstants";
import {getFileService} from "../../../services/services";
import {getToken} from "../../../Utils/utils";
import keycloak from "../../../Utils/keycloak";
import { isCordovaAvailable } from "../../../Utils/secureStorageUtil";
import { saveImagesActionCreator } from "../../../actions/commonActions";

function Footer() {
  const supportEmail = MULTITENANT_CONSTANTS[TENANT]?.supportEmail;
  const { interfaceUrls } = useSelector((state) => state.commonState);
  const { sponsors } = useSelector((state) => state.commonState);
  const { images } = useSelector((state) => state.commonState);
  const { t } = useTranslation();
  const isMobile = isCordovaAvailable();
  const { i18n } = useTranslation();
  const dispatch = useDispatch();

  const [imageUrls, setImageUrls] = useState({});
  const downloadedImages = useRef([]);

  const getUrlByLanguage = (field) => {
    const currentLanguage = i18n.language;
    return interfaceUrls[currentLanguage]?.[field];
  };

  const getFileCallback = (response, imageId) => {
    const newImage = {id: imageId, url: response.data.data.asset_url};
    downloadedImages.current = [...downloadedImages.current, newImage];
    dispatch(saveImagesActionCreator([...images, ...downloadedImages.current]));
        setImageUrls((prevUrls) => ({
            ...prevUrls,
            [imageId]: `${URL_BASE_IMAGE}${response.data.data.asset_url}`,
        }));
    };

    const getImageSponsor = (imageId) => {
        const userToken = getToken(keycloak);
        const existingImage = images.find((image) => image.id === imageId);
        if (existingImage) {
          setImageUrls((prevUrls) => ({
            ...prevUrls,
            [imageId]: `${URL_BASE_IMAGE}${existingImage.url}`,
          }));
        } else {
          getFileService(MULTITENANT_CONSTANTS[TENANT].tenantServer, imageId, userToken, (response) => getFileCallback(response, imageId));
        }
    };

    const buttonImageFooter = (sponsorItem) => {
      return (
        <button
          className="ImageButton"
          onClick={(e) => {
            e.preventDefault();
              if (sponsorItem.onclickurl) {
                if (isMobile) {
                window.cordova.InAppBrowser.open(sponsorItem.onclickurl, "_system");
                } else {
                window.open(sponsorItem.onclickurl, "_blank");
              }
            }
          }}
        >
          <img
            className="ImageEurope"
            src={imageUrls[sponsorItem?.logo]}
            alt={sponsorItem?.company}
          />
        </button>
      );
    }

    useEffect(() => {
        sponsors.forEach((sponsor) => {
            if (sponsor.logo) {
                getImageSponsor(sponsor.logo);
            }
      if (sponsor.child && sponsor.child.length > 0) {
        sponsor.child.forEach((childSponsor) => {
          if (childSponsor.logo) {
            getImageSponsor(childSponsor.logo);
          }
        });
       }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sponsors]);


  return (
    <div className="Footer">
      <div className="FooterBody">
        {sponsors &&
          sponsors.map((sponsor, index) => {
            if (sponsor.child && sponsor.child.length > 0) {
              return (
                <div key={`sponsor-line-${index}`} className="SponsorLine">
                  {sponsor.child.map((childSponsor, childIndex) => (
                    !!childSponsor?.logo && (
                      <div key={`${childSponsor?.company}-${childIndex}`} className="ImageDiv">
                        {buttonImageFooter(childSponsor)}
                      </div>
                    )
                  ))}
                </div>
              );
            }
            else if (!!sponsor?.logo) {
              return (
                <div key={`${sponsor?.company}-${index}`} className="ImageDiv">
                  {buttonImageFooter(sponsor)}
                </div>
              );
            }
            return null;
          })
        }
        <span className="versionTag">{isMobile ? (packageJson.mobileVersion || packageJson.version) : packageJson.version}</span>
      </div>
      {!!supportEmail && (
        <div className={"footerLink"}>
            <div>
                <a href={`mailto:${supportEmail}`} target={"_blank"} rel="noreferrer">
                        {t("suport.contact")} {supportEmail}
                    </a>
            </div>
        </div>
          )}

        <div className={"footerLink"}>
        {!!MULTITENANT_CONSTANTS[TENANT]?.urlFaqs && (
            <div>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a href="#"
                  rel="noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    if (isMobile) {
                      window.cordova.InAppBrowser.open(
                        MULTITENANT_CONSTANTS[TENANT]?.urlFaqs?.[i18n.language] || MULTITENANT_CONSTANTS[TENANT]?.urlFaqs,
                        "_system"
                      );
                    } else {
                      window.open(MULTITENANT_CONSTANTS[TENANT]?.urlFaqs?.[i18n.language] || MULTITENANT_CONSTANTS[TENANT]?.urlFaqs, "_blank");
                    }
                  }}>
                        {t("suport.faqs")}
                </a>
            </div>
            )}
            {getUrlByLanguage('terms_conditions_url') && (
          <div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a href="#"
                rel="noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  const termsUrl = getUrlByLanguage('terms_conditions_url');
                  
                  if (isMobile) {
                    window.cordova.InAppBrowser.open(termsUrl, "_system");
                  } else {
                    window.open(termsUrl, "_blank");
                  }
                }}>
                  {t("legal.termsAndConditions")}
              </a>
          </div>
        )}
          {getUrlByLanguage('privacy_url') && (
              <div>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="#"
                    rel="noreferrer"
                    onClick={(e) => {
                      e.preventDefault();
                      const privacyUrl = getUrlByLanguage('privacy_url');
                      
                      if (isMobile) {
                        window.cordova.InAppBrowser.open(privacyUrl, "_system");
                      } else {
                        window.open(privacyUrl, "_blank");
                      }
                    }}>
                      {t("legal.privacyStatement")}
                  </a>
              </div>
          )}
          <div>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              {!isMobile && <a href="#" className="cky-banner-element">
                  {t("suport.cookies")}
              </a>}
        </div>
      </div>
    </div>
  );
}

export default Footer;
